// translations/ru.ts
import { TranslationKeys } from '../index';

export const ru: TranslationKeys = {
  header: {
    tutorialButton: "Обучение",
    currentLanguage: "Текущий"
  },
  hero: {
    title: "Играйте в Судоку VS прямо сейчас!",
    description: "Приготовьтесь к такому вызову в Судоку, какого еще не было! Наслаждайтесь одиночной практикой или сражайтесь с друзьями — скачайте сейчас и испытайте восторг!",
    howToPlay: "Как играть",
    googlePlay: {
      topText: "Загрузите в",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "Загрузите в",
      bottomText: "App Store"
    },
    botButtonShow: "Нужна помощь? Спросите нашего бота!",
    botButtonHide: "Скрыть помощника"
  },
  footer: {
    followUs: "ПОДПИСЫВАЙТЕСЬ НА НАС",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. Все права защищены."
  },
  beginnersGuide: {
    modalTitle: "РУКОВОДСТВО ДЛЯ НАЧИНАЮЩИХ",
    originsTab: "ПРОИСХОЖДЕНИЕ СУДОКУ",
    basicsTab: "ОСНОВЫ СУДОКУ",
    rulesTab: "ПРАВИЛА ИГРЫ VS",
    origins: {
      bulletOne: "Вдохновлено латинскими квадратами; впервые опубликовано в 1979 году Говардом Гарнсом.",
      bulletTwo: "Стало популярным в Японии в 1980-х годах под названием «Судоку». Получило мировую известность в 2000-х.",
      bulletThree: "Сетка 9x9 с девятью подсетками 3x3; заполните цифрами от 1 до 9 без повторений в строках, столбцах или подсетках.",
      bulletFour: "Любимо миллионами, с множеством вариаций и новых вызовов.",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "Заполните пропущенное число!",
      correct: "ВЕРНО!",
      incorrect: "НЕВЕРНО",
      instructions: "Завершите головоломку 3X3, введя правильное число в выделенное место. Каждая строка, столбец и блок должны содержать каждое число ровно один раз. Выберите правильное число. Выбирайте с умом!",
      feedbackCorrect: "ВЫ РЕШИЛИ СВОЙ ПЕРВЫЙ БЛОК!",
      feedbackIncorrect: "ПОПРОБУЙТЕ СНОВА!",
      basicsStep2: {
        instructions: "Завершите головоломку 4X4, выбрав правильное число для выделенного места. Каждая строка, столбец и блок должны содержать каждое число ровно один раз. Выберите правильное число. Выбирайте с умом!",
        feedbackCorrect: "ВЫ НА ВЕРНОМ ПУТИ!"
      },
      basicsStep3: {
        instructions: "Завершите головоломку 4X4, выбрав правильное число для выделенного места. Каждая строка, столбец и блок должны содержать каждое число ровно один раз. Выберите правильное число. Выбирайте с умом!",
        feedbackCorrect: "ИДЕАЛЬНОЕ РЕШЕНИЕ!",
        feedbackIncorrect: "НЕВЕРНО - ПОПРОБУЙТЕ СНОВА!"
      },
      congratulations: {
        title: "Поздравляем!",
        subtitle: "Вы успешно завершили обучение основам Судоку! Ваше усердие и старания окупились, и теперь у вас есть все необходимые навыки для уверенного решения головоломок Судоку.",
        nextStepsTitle: "Следующие шаги",
        nextStepsText: "Теперь пришло время проверить свои навыки! Скачайте игру Судоку сегодня и погрузитесь в разнообразие головоломок. Независимо от того, предпочитаете ли вы быструю одиночную игру или хотите поучаствовать в дружеском соревновании, вы можете выбрать игру в одиночном режиме или в режиме противостояния против оппонента.",
        ctaHeader: "Готовы к игре?",
        ctaHighlight: "Скачать сейчас!",
        rulesTitle: "Освойте правила игры",
        rulesText: "Прежде чем начать, обязательно ознакомьтесь с Правилами игры Sudoku VS. Понимание правил и системы очков может дать вам преимущество в игре против оппонентов. Эти знания улучшат ваш опыт и помогут эффективно разрабатывать стратегию!"
      }
    },
    gameRules: {
      notification: {
        important: "Важно: ",
        text: "Включите уведомления для лучшего опыта!"
      },
      rulesHeader: "Правила",
      rulesList: {
        rule1_pre: "Примите или создайте приглашение на ",
        rule1_strong: "дружеский или случайный матч",
        rule1_post: ".",
        rule2_pre: "Игрок, который ходит первым, ",
        rule2_strong: "выбирается случайным образом.",
        rule3: "Игроки ходят по очереди, пока доска не будет заполнена.",
        rule4_pre1: "Каждый ",
        rule4_strong1: "ход длится 60 секунд,",
        rule4_pre2: " с лимитом в ",
        rule4_strong2: "5 чисел за ход.",
        rule5_pre: "Разрешена только ",
        rule5_strong: "1 подсказка",
        rule5_post: " за ход.",
        rule6_pre: "Игрок с ",
        rule6_strong: "наибольшим количеством очков побеждает",
        rule6_post: " в игре.",
        rule7_pre: "В случае ",
        rule7_strong_pre: "ничьей",
        rule7_pre2: ", игрок с большим количеством вводов ",
        rule7_strong_post: "побеждает",
        rule7_post: " в игре.",
        rule8: "Если вы не сделаете ход в течение 24 часов, вы автоматически проигрываете игру."
      },
      rulesWarning: "Сделайте свой ход в течение 24 часов, иначе вы автоматически проиграете игру",
      gameControls: {
        header: "Управление игрой",
        list: {
          control1_pre: "Используйте ",
          control1_strong: "Флаг сдачи",
          control1_post: ", чтобы сдаться.",
          control2_pre: "Используйте ",
          control2_strong: "Ластик",
          control2_post: ", чтобы исправить ошибку.",
          control3_pre: "Используйте ",
          control3_strong: "Закончить ход",
          control3_post: ", если вы сделали все свои вводы до истечения времени."
        }
      },
      scoring: {
        header: "Подсчет очков",
        list: {
          score1_pre1: "Заработайте ",
          score1_strong1: "1 очко",
          score1_pre2: " за ",
          score1_span: "правильное",
          score1_post: " размещение числа.",
          score2_pre1: "Потеряйте ",
          score2_strong1: "1 очко",
          score2_pre2: " за каждое ",
          score2_span: "неправильное",
          score2_post: " размещение числа.",
          score3_pre1: "Заработайте ",
          score3_strong1: "5 очков",
          score3_pre2: " за каждую решенную строку, столбец и блок.",
          score3_span: "решенную",
          score3_post: ""
        }
      },
    },
    controller: {
      previous: "Назад",
      of: " из ",
      close: "Закрыть",
      next: "Далее",
      gameRules: "Правила игры",
    },
  },
  tutorials: {
    modalTitle: "Обучение",
    tabs: {
      introduction: "Введение",
      gettingStarted: "Начало работы",
      vsFriends: "Против друзей",
      howToPlay: "Как играть",
    },
    messages: {
      loading: "Загрузка обучения...",
      error: "Ошибка загрузки обучения:",
      fallback: "Использование резервных данных...",
      empty: "Для этого раздела нет доступных обучений.",
    },
  },
  cookieConsent: {
    title: "Управление настройками согласия",
    description: "Мы используем файлы cookie для улучшения вашего опыта в Sudoku VS, анализа нашего трафика и предоставления персонализированной рекламы.",
    acceptAll: "Принять все файлы cookie",
    confirmChoices: "Подтвердить выбор",
    performance: {
      title: "Файлы cookie производительности",
      description: "Позволяют нам собирать данные для улучшения нашей игры и услуг с помощью аналитики использования."
    },
    advertising: {
      title: "Реклама",
      adStorage: "Разрешает хранение рекламных данных на вашем устройстве",
      adMeasurement: "Разрешает сбор данных для измерения рекламы",
      adPersonalization: "Позволяет нам показывать вам персонализированную рекламу на основе ваших интересов"
    },
    landing: {
        title: "Уведомление о файлах cookie",
        description: "Мы используем файлы cookie для улучшения вашего опыта в Sudoku VS, анализа нашего трафика и предоставления персонализированной рекламы. Вы можете указать, какие файлы cookie вы хотите разрешить, прежде чем продолжить.",
        acceptAll: "Принять все файлы cookie",
        customizeSettings: "Настроить параметры",
        fineprint: "Нажимая «Принять все файлы cookie», вы соглашаетесь с тем, что<br />Sudoku VS может хранить файлы cookie на вашем устройстве"
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},

  privacyPolicy: {
    modalTitle: "Политика Конфиденциальности",
    sections: {
      introduction: {
        title: "1. Введение",
        p1: "Добро пожаловать в Sudoku VS. Мы стремимся защищать вашу конфиденциальность и обеспечивать вам положительный опыт на нашем веб-сайте. Эта Политика Конфиденциальности объясняет, как мы собираем, используем и защищаем вашу информацию при использовании нашей игровой платформы Sudoku.",
        p2: "Используя Sudoku VS, вы соглашаетесь на сбор и использование информации в соответствии с этой политикой."
      },
      informationWeCollect: {
        title: "2. Информация, Которую Мы Собираем",
        p1: "Мы собираем различные типы информации для предоставления и улучшения наших услуг:",
        list: {
          usageData: "Данные об Использовании: Мы автоматически собираем информацию о том, как вы взаимодействуете с нашей игрой, включая статистику игры, время завершения головоломок, уровни сложности и предпочтения в игре.",
          deviceInfo: "Информация об Устройстве: Мы можем собирать информацию об устройстве, которое вы используете для доступа к Sudoku VS, включая тип устройства, тип браузера, IP-адрес и операционную систему.",
          cookies: "Куки и Данные Отслеживания: Мы используем куки и аналогичные технологии отслеживания для улучшения вашего опыта и сбора аналитических данных."
        }
      },
      howWeUseInfo: {
        title: "3. Как Мы Используем Вашу Информацию",
        p1: "Мы используем собранную информацию для следующих целей:",
        list: {
          gameImprovement: "Улучшение Игры: Для анализа игровых паттернов и улучшения наших головоломок Sudoku, алгоритмов сложности и общего пользовательского опыта.",
          performanceAnalytics: "Аналитика Производительности: Для мониторинга и анализа тенденций использования, измерения эффективности наших услуг и выявления областей для улучшения.",
          personalization: "Персонализация: Для предоставления вам персонализированных игровых рекомендаций и адаптированного контента на основе ваших игровых предпочтений.",
          technicalSupport: "Техническая Поддержка: Для устранения неполадок, исправления ошибок и обеспечения бесперебойной работы нашей платформы."
        }
      },
      cookies: {
        title: "4. Куки и Технологии Отслеживания",
        p1: "Sudoku VS использует куки для улучшения вашего опыта. У вас есть возможность управлять настройками куки:",
        performanceCookies: {
          title: "Куки Производительности:",
          description: "Эти куки позволяют нам собирать данные для улучшения нашей игры и услуг через аналитику использования. Они помогают нам понять, как игроки взаимодействуют с нашими головоломками, какие функции наиболее популярны и где мы можем внести улучшения. Эти данные необходимы для улучшения игрового процесса и создания лучших впечатлений от Sudoku."
        },
        advertisingCookies: {
          title: "Рекламные Куки:",
          list: [
            "Разрешают хранение рекламных данных на вашем устройстве",
            "Включают сбор данных для измерения и эффективности рекламы",
            "Позволяют нам показывать вам персонализированную рекламу на основе ваших интересов и игрового поведения"
          ]
        },
        p2: "Вы можете управлять настройками куки через баннер согласия на куки, который появляется при первом посещении нашего веб-сайта. Вы можете изменить настройки в любое время через настройки вашего браузера, хотя отключение определенных куки может повлиять на функциональность веб-сайта."
      },
      thirdParty: {
        title: "5. Сторонние Сервисы",
        p1: "Sudoku VS интегрируется со следующими сторонними сервисами:",
        gemini: {
          title: "ИИ-Ассистент Google Gemini:",
          description: "Наш бот помощи работает на Google Gemini со встроенной базой знаний, чтобы помогать вам с вопросами, связанными с игрой, предоставлять советы по Sudoku и помогать в устранении неполадок. Когда вы взаимодействуете с ботом, ваши запросы могут обрабатываться системами Google. Пожалуйста, обратитесь к Политике Конфиденциальности Google для получения информации о том, как они обрабатывают данные."
        },
        youtube: {
          title: "Встроенные Видео YouTube:",
          description: "Мы используем наложения видео YouTube для предоставления учебного контента и руководств по игре непосредственно на нашем веб-сайте. Когда вы взаимодействуете с этими видео, YouTube может собирать данные в соответствии со своей политикой конфиденциальности. Вы можете смотреть видео, не покидая Sudoku VS, но механизмы отслеживания YouTube могут все еще применяться."
        },
        advertising: {
          title: "Рекламные Партнеры:",
          description: "Мы работаем со сторонними рекламными партнерами для показа рекламы на нашей платформе. Эти партнеры могут использовать куки и аналогичные технологии для сбора информации о вашей активности просмотра в целях персонализированной рекламы."
        }
      },
      dataSecurity: {
        title: "6. Безопасность Данных",
        p1: "Мы серьезно относимся к безопасности ваших данных и реализуем соответствующие технические и организационные меры для защиты вашей информации от несанкционированного доступа, изменения, раскрытия или уничтожения. Однако, пожалуйста, учтите, что ни один метод передачи через Интернет или электронного хранения не является 100% безопасным.",
        p2: "Наш веб-сайт использует отраслевые стандартные протоколы безопасности и проверен печатью безопасности GoDaddy для обеспечения безопасного просмотра."
      },
      privacyRights: {
        title: "7. Ваши Права на Конфиденциальность",
        p1: "У вас есть определенные права в отношении вашей личной информации:",
        list: {
          access: "Доступ: Вы можете запросить информацию о данных, которые мы храним о вас",
          correction: "Исправление: Вы можете запросить исправление неточной информации",
          deletion: "Удаление: Вы можете запросить удаление ваших данных, с учетом юридических обязательств",
          optOut: "Отказ: Вы можете отказаться от персонализированной рекламы через настройки куки",
          portability: "Портативность Данных: Вы можете запросить копию ваших данных в портативном формате"
        }
      },
      childrenPrivacy: {
        title: "8. Конфиденциальность Детей",
        p1: "Sudoku VS предназначен для общей аудитории. Мы не собираем преднамеренно личную информацию от детей младше 13 лет. Если вы являетесь родителем или опекуном и считаете, что ваш ребенок предоставил нам личную информацию, пожалуйста, свяжитесь с нами, чтобы мы могли принять соответствующие меры."
      },
      changes: {
        title: "9. Изменения в этой Политике Конфиденциальности",
        p1: "Мы можем время от времени обновлять эту Политику Конфиденциальности, чтобы отражать изменения в нашей практике или по юридическим, операционным или нормативным причинам. Мы уведомим вас о любых существенных изменениях, разместив новую Политику Конфиденциальности на этой странице и обновив дату «Последнего обновления» ниже.",
        p2: "Мы рекомендуем вам периодически пересматривать эту Политику Конфиденциальности, чтобы быть в курсе того, как мы защищаем вашу информацию."
      },
      contact: {
        title: "10. Свяжитесь с Нами",
        p1: "Если у вас есть какие-либо вопросы, опасения или запросы относительно этой Политики Конфиденциальности или наших практик работы с данными, пожалуйста, свяжитесь с нами:",
        email: "Электронная почта: privacy@sudoku.vs",
        website: "Веб-сайт: www.sudoku.vs",
        p2: "Мы ответим на ваш запрос как можно скорее."
      }
    },
    footer: {
      lastUpdated: "Последнее обновление: 10 октября 2025 г.",
      effectiveDate: "Дата вступления в силу: 10 октября 2025 г."
    }
  },
  copywright: {
    text: 'Авторское право © 2025 Software Architects Ltd. Все права защищены.'
  }
};